import { BaseResource } from "utils/ApiUtils";

export default class FieldMaterials extends BaseResource {
    constructor(args) {
      // if(!args.DateAdded) { console.warn("Missing DateAdded attribute") };
      // if(!args.FieldMaterialId) { console.warn("Missing FieldMaterialId attribute") };
      // if(!args.Supplier) { console.warn("Missing Supplier attribute") };
      // if(!args.ProjectId) { console.warn("Missing ProjectId attribute") };
      // Object.keys(args).forEach(key => {
      //   if(!FieldMaterials.attributes.includes(key.substr(0).toLowerCase() + key.slice(1))){
      //     console.warn(`FieldMaterials was fed a attribute that does not exist in the class: ${key}`)
      //   }
      // });
      super(args, FieldMaterials.attributes);
  
      // different field based on from odata or import tool
      const xrefMaterialForms = args.xrefMaterialForms ? args.xrefMaterialForms : [];
      if(xrefMaterialForms.length > 0) {
        this.FieldForms = xrefMaterialForms.map(val => val.Form.TestType).toString();
        this.FieldFormId = xrefMaterialForms.map(val => val.Form.FormId).toString();
      }
    };
  
    static columns = [
      { title: "Error", field: "Error", hidden: true },
      { title: "IsUpdate", field: "IsUpdate", hidden: true },
      { title: "Supplier", field: "Supplier" },
      { title: "Product Type", field: "Category" },
      { title: "Material Code", field: "MaterialCode", defaultSort: "asc" },
      { title: "Description", field: "MaterialDesc" },
      { title: "Subcategory", field: "MaterialSub" },
      { title: "SpecItem", field: "SpecItem" },
      { title: "Project Id", field: "ProjectId", hidden: true},
      { title: "Field Forms", field: "FieldForms", filter: false, sorting: false },
      { title: "Field Forms", field: "FieldFormId", hidden: true },
      { title: "FieldMaterialId", field: "FieldMaterialId", hidden: true },
      { title: "AddedBy", field: "AddedBy", hidden: true },
      { title: "Notes", field: "Notes", hidden: true },
      { title: "Xref", field: "xrefMaterialForms", hidden: true },
      { title: "DateAdded", field: "DateAdded", hidden: true },
      { title: "FieldFormId", field: "FieldFormId", hidden: true },
      { title: "Active?", field: "IsActive", type: "boolean" },
      //{ title: "Edit", field: "Edit" },
      { title: "Delete", field: "Delete" }
    ]
  
    static attributes = FieldMaterials.columns.map(r => r.field);
  
    static expand = [{ "XrefMaterialForms": { "expand": [{ "Form": { "select": ["FormId", "TestType"] } }], filter: { IsActive: true } }}];
    
  };
  
  